import { find } from 'lodash';

import { OrderInventoryType, ProductType } from '@/types';

import { isEsProduct, isStorageProduct, isWarranty } from '../../constants';
import { OrderItemWrapper, ProductLineName } from '../../types';

import { ProductErrors } from './types';

export const canHaveErrors = (
  productLineName: ProductLineName,
  isPartialReRoofDeselected: boolean,
) => productLineName === 'Timberline Solar™' || isPartialReRoofDeselected;

const isZeroQuantityProduct = (orderItems: OrderItemWrapper[], productType: number): boolean => {
  const product = find(orderItems, oi => oi.priceBookEntry.product.type === productType);

  if (!product) {
    return false;
  }

  return !(product && product.orderItem.quantity > 0);
};

const isColorSelected = (orderItems: OrderItemWrapper[], productType: number): boolean => {
  const product = find(orderItems, oi => oi.priceBookEntry.product.type === productType);

  if (!product?.orderItem.quantity) {
    return false;
  }

  return Boolean(product.priceBookEntry.asphaltShingleColor);
};

export const getProductErrors = ({
  state,
  allPriceBookEntries,
  isPartialReRoofDeselected,
  productLineName,
  inventorySelected,
}: ProductErrors) => {
  const orderItems = state.visibleOrderItems;
  const errors: string[] = [];

  if (productLineName === 'Timberline Solar™' && !inventorySelected) {
    errors.push('Select available inventory for this order');
  }

  const esProductHasZeroQuantity =
    state.visibleOrderItems.find(({ priceBookEntry }) => isEsProduct(priceBookEntry.product))
      ?.orderItem.quantity === 0;

  if (
    state.order.inventoryType === OrderInventoryType['Some Inventory'] &&
    esProductHasZeroQuantity
  ) {
    errors.push('Add ES product quantity');
  }

  const isTimberlineError =
    state.esShingleQuantity && !isColorSelected(orderItems, ProductType['Asphalt Shingle']);

  if (isTimberlineError) {
    errors.push('Select or remove Timberline Solar HD™');
  }

  const isRidgeCapError =
    state.isRidgeCapSectionEnabled && isZeroQuantityProduct(orderItems, ProductType['Ridge Cap']);

  if (isRidgeCapError) {
    errors.push('Select or remove Seal-A-Ridge® Ridge Cap Shingle');
  }

  if (isPartialReRoofDeselected) {
    errors.push('Select an answer for “Is this a partial roof replacement?”');
  }

  const storageProduct = orderItems.find(({ priceBookEntry }) => isStorageProduct(priceBookEntry));

  if (storageProduct && state.isAccessProgram && !state.order.batteryPrice) {
    errors.push('Enter price for Energy Storage');
  }

  const warranty = allPriceBookEntries.find(
    item => isWarranty(item) && !item.product.isPreSelected && item.isProductAvailable,
  );
  const noWarrantySelected = !orderItems.find(
    ({ priceBookEntry }) => isWarranty(priceBookEntry) && !priceBookEntry.product.isPreSelected,
  );

  if (warranty && noWarrantySelected && state.isAccessProgram) {
    errors.push('Select a warranty');
  }

  return errors;
};
